import type { FC, ReactNode } from 'react'

import { useRouter } from 'next/router'
import { Wordmark } from '@/components/generals/wordmark'
import { WhatsAppLink } from '@/components/generals/whatsapp-link'

import { brand, contact, navItems } from '@/constants/content'

export const SiteFooter: FC = (): ReactNode => {
    const { pathname } = useRouter()
    const prefix = pathname === '/' ? '' : '/'

    return (
        <footer id='footer' className='border-t border-soft-white/10 bg-navy-900'>
            <div className='container-site grid gap-10 py-14 md:grid-cols-[1.4fr_1fr] md:gap-16'>
                <div className='max-w-md'>
                    <Wordmark className='text-2xl' />

                    <p className='mt-4 font-heading text-lg font-semibold text-soft-white'>
                        {brand.tagline}
                    </p>

                    <p className='mt-2 text-sm leading-relaxed text-cool-grey-light'>
                        {brand.description}
                    </p>

                    <p className='mt-5 text-xs font-semibold tracking-[0.18em] text-orange'>
                        {brand.phrase}
                    </p>
                </div>

                <div className='grid gap-8 sm:grid-cols-2'>
                    <nav aria-label='Footer'>
                        <h2 className='text-xs font-semibold tracking-[0.16em] text-cool-grey-light uppercase'>
                            Explore
                        </h2>

                        <ul className='mt-3 flex flex-col'>
                            {navItems.map(item => (
                                <li key={item.sectionId}>
                                    <a
                                        href={`${prefix}#${item.sectionId}`}
                                        className='inline-flex min-h-11 items-center text-sm text-soft-white/85 transition-colors hover:text-orange'
                                    >
                                        {item.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </nav>

                    <div>
                        <h2 className='text-xs font-semibold tracking-[0.16em] text-cool-grey-light uppercase'>
                            Contact
                        </h2>

                        <p className='mt-3 text-sm text-soft-white/85'>
                            {brand.founder.name}
                        </p>

                        <p className='text-sm text-cool-grey-light'>
                            {brand.founder.title}
                        </p>

                        <a
                            href={`${prefix}#contact`}
                            className='mt-2 inline-flex min-h-11 items-center text-sm font-medium text-orange transition-colors hover:text-orange-light'
                        >
                            {contact.enquiriesStatus}
                        </a>

                        <WhatsAppLink variant='text' className='mt-1 min-h-11 text-sm' />
                    </div>
                </div>
            </div>

            <div className='border-t border-soft-white/10'>
                <div className='container-site flex flex-col gap-2 py-6 text-xs text-cool-grey-light md:flex-row md:items-center md:justify-between'>
                    <p>
                        {brand.copyright}
                    </p>

                    <p className='max-w-xl md:text-right'>
                        {brand.disclaimer}
                    </p>
                </div>
            </div>
        </footer>
    )
}
